// const example = {
//   email: ["Masukkan alamat email yang valid."],
//   password: ["Ensure this field has at least 8 characters."],
//   organisasi: [{ emailOrganisasi: ["Masukkan alamat email yang valid."] }],
// };

const errorHandler = (err) => {
  console.log(err)
  console.dir(err)

  console.log('error.response: ', err.response)
  console.log('error.data: ', err.data)

  let message = ''

  if(typeof err === 'string'){
    message = err
  }
  else if(err.data) {
    message = handleErrorData(err.data)
  }
  else if(err.response){
    if(err.response.data){
      message = handleErrorData(err.response.data)
    } else {
      message = JSON.stringify(err.response)
    }
  }
  else if(err.message) {
    if(typeof err.message === 'string') {
      message = err.message
    } else {
      message = JSON.stringify(err.message)
    }
  }
  else {
    message = JSON.stringify(err)
  }

  return message.includes('doctype') || message.includes('DOCTYPE') ? message : trim(message)
}

export { errorHandler }

// Helpers
function handleFieldErrors(fields, data){
  let result = ''
  for (let index = 0; index < fields.length; index++) {
    const field = fields[index];

    // Check nested object
    const firstErrorMessageOfField = data[field][0]
    if(firstErrorMessageOfField && typeof firstErrorMessageOfField === 'string'){

      // Render array of strings into result
      if(typeof data[field].join === 'function'){
        result += `${field}: ${data[field].join(', ')} \n`
      } else {
        result += `${field}: ${JSON.stringify(data[field])} \n`
      }
    }
    else if(!firstErrorMessageOfField && Object.keys(data[field]).length > 0){
      const subData = data[field]
      const subFields = Object.keys(subData)

      // !!! Recursive
      result += handleFieldErrors(subFields, subData)
    }
    else {
      result += `${field}: ${JSON.stringify(data[field])} \n`
    }
  }
  return result
}

function handleErrorData(data){
  let result = ''

  if(typeof data === 'string'){
    result = data
  } else if (data.message && typeof data.message === 'string') {
    result = data.message
  } else {
    if(data.nonFieldErrors && data.nonFieldErrors.length > 0){
      if(typeof data.nonFieldErrors[0] === 'string'){
        for (let index = 0; index < data.nonFieldErrors.length; index++) {
          const string = data.nonFieldErrors[index];
          result += `${string}${index < data.nonFieldErrors.length-1 ? ', ' : ''}`
        }
      }
    } else {
      let fields = Object.keys(data)
      if(fields && fields.length > 0){
        result = handleFieldErrors(fields, data)
      } else {
        result = JSON.stringify(data)
      }
    }
  }

  return result
}

function trim(string){
  if(string && string.length > 200){
    return string.slice(0, 200)
  }

  return string
}
